import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'video_split',
    props: ['d'],
    setup(__props) {
        const props = __props;
        function getVideoSplitData() {
            return {
                background_colour: props.d.background_colour,
                font_style: props.d.absolute_brand_font,
                line_one: props.d.line_one,
                line_two: props.d.line_two,
                line_three: props.d.line_three,
                leadin: props.d.leadin,
                video_mp4: props.d.video_mp4,
                video_webm: props.d.video_webm,
                video_poster: props.d.video_poster,
                video_autoplay: props.d.video_autoplay,
                repeatable_cta: [
                    {
                        'cta_title': props.d.cta_text,
                        'cta_link': props.d.cta_link
                    }
                ],
                padding_top: props.d.padding_top,
                padding_bottom: props.d.padding_bottom
            };
        }
        return (_ctx, _cache) => {
            const _component_image_split = _resolveComponent("image-split");
            return (_openBlock(), _createBlock(_component_image_split, {
                d: getVideoSplitData()
            }, null, 8, ["d"]));
        };
    }
});
